"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var IconIndex;
(function (IconIndex) {
    IconIndex["DASHBOARD"] = "dashboard";
    IconIndex["CLIENTS"] = "clients";
    IconIndex["DOT_GRID"] = "dot-grid";
    IconIndex["DOWNLOAD"] = "download";
    IconIndex["UPLOAD"] = "upload";
    IconIndex["DELETE"] = "delete";
    IconIndex["ACTIVITY"] = "activity";
    IconIndex["TIMES"] = "times";
    IconIndex["CLOCK"] = "clock";
    IconIndex["SUCCESS"] = "success";
})(IconIndex = exports.IconIndex || (exports.IconIndex = {}));
//# sourceMappingURL=IconIndex.enum.js.map